import type { CSSProperties } from 'react';

const BRAND_GRADIENT = 'linear-gradient(135deg, #444ab2 0%, #459fec 100%)';

// Tilts the rocker so the pressed half sinks into the plate and the other half sticks out.
export function rockerStyle(checked: boolean): CSSProperties {
  return {
    transform: `rotateY(${checked ? 18 : -18}deg)`,
    boxShadow: checked
      ? '-3px 0 3px -1px rgba(15, 23, 42, 0.35), inset 1px 0 0 rgba(255, 255, 255, 0.6)'
      : '3px 0 3px -1px rgba(15, 23, 42, 0.35), inset -1px 0 0 rgba(255, 255, 255, 0.6)',
  };
}

// Like a real illuminated switch, the locator light glows when the light is off.
export function indicatorStyle(checked: boolean): CSSProperties | undefined {
  return checked ? undefined : { background: BRAND_GRADIENT, boxShadow: '0 0 6px 1px rgba(69, 159, 236, 0.8)' };
}
